/*
 * Candidate App Settings Tab Messages
 *
 * This contains all the text for the Candidate App Settings Tab component.
 */

import { defineMessages } from 'react-intl';
export const scope =
  'src.pages.CandidatesDetailsPage.components.CandidateAppSettingsTab';

export default defineMessages({
  mobileApp: {
    id: `${scope}.mobileApp`,
    defaultMessage: 'Mobile App',
  },
  language: {
    id: `${scope}.language`,
    defaultMessage: 'Language',
  },
  appVersion: {
    id: `${scope}.appVersion`,
    defaultMessage: 'App Version',
  },
  operationSystem: {
    id: `${scope}.operationSystem`,
    defaultMessage: 'Operation System',
  },
  notifications: {
    id: `${scope}.notifications`,
    defaultMessage: 'Notifications',
  },
  essentialUpdates: {
    id: `${scope}.essentialUpdates`,
    defaultMessage: 'Essential Updates',
  },
  standardJobUpdates: {
    id: `${scope}.standardJobUpdates`,
    defaultMessage: 'Standard Job Updates',
  },
  priorityJobsUpdates: {
    id: `${scope}.priorityJobsUpdates`,
    defaultMessage: 'Priority Jobs Updates',
  },
  on: {
    id: `${scope}.on`,
    defaultMessage: 'On',
  },
  off: {
    id: `${scope}.off`,
    defaultMessage: 'Off',
  },
  zupAccess: {
    id: `${scope}.zupAccess`,
    defaultMessage: 'ZUP Access',
  },
  confirmZupAccessMessage: {
    id: `${scope}.confirmZupAccessMessage`,
    defaultMessage: 'Are you sure you want to give ZUP Access to {name}?',
  },
  cancelZupAccessMessage: {
    id: `${scope}.cancelZupAccessMessage`,
    defaultMessage: 'Are you sure you want to revoke ZUP Access for {name}?',
  },
});
